import { AgentVersion, ByoaAgent } from '@/types/agent';

export function getLatestVersionEntry( versions: Record<string, AgentVersion> ): AgentVersion {
  const maxKey = Math.max( ...Object.keys( versions ).map( Number ) ).toString();
  return versions[maxKey];
}


export function getLowCodeAgentDisplayId( name: string ): string {
  return `low_code.${ name }`;
}

export function getScalingInitialConfig( byoaAgent: ByoaAgent | undefined ) {
  const autoScalingConfig = byoaAgent?.autoScalingConfig;
  const isAutoScaling = !!autoScalingConfig?.enabled;

  if ( isAutoScaling ) {
    return {
      autoScaling: true as const,
      minInstances: autoScalingConfig?.minReplicas ?? 1,
      maxInstances: autoScalingConfig?.maxReplicas ?? 2,
      cpuUtilizationEnabled: autoScalingConfig?.targetCpuUtilization !== undefined,
      targetCpuUtilization: autoScalingConfig?.targetCpuUtilization ?? 75,
      memoryUtilizationEnabled: autoScalingConfig?.targetMemoryUtilization !== undefined,
      targetMemoryUtilization: autoScalingConfig?.targetMemoryUtilization ?? 75
    };
  }

  return {
    autoScaling: false as const,
    instances: byoaAgent?.replicas ?? 0
  };
}
